/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface PnoEntry
 */
export interface PnoEntry {
    /**
     * 
     * @type {string}
     * @memberof PnoEntry
     */
    currency?: string;
    /**
     * 
     * @type {number}
     * @memberof PnoEntry
     */
    pnoNet?: number;
    /**
     * 
     * @type {number}
     * @memberof PnoEntry
     */
    pnoGross?: number;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PnoEntry
     */
    spendMarketing?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PnoEntry
     */
    turnoverNet?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof PnoEntry
     */
    turnoverGross?: MoneyOutput;
}

/**
 * Check if a given object implements the PnoEntry interface.
 */
export function instanceOfPnoEntry(value: object): value is PnoEntry {
    return true;
}

export function PnoEntryFromJSON(json: any): PnoEntry {
    return PnoEntryFromJSONTyped(json, false);
}

export function PnoEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PnoEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'pnoNet': json['pnoNet'] == null ? undefined : json['pnoNet'],
        'pnoGross': json['pnoGross'] == null ? undefined : json['pnoGross'],
        'spendMarketing': json['spendMarketing'] == null ? undefined : MoneyOutputFromJSON(json['spendMarketing']),
        'turnoverNet': json['turnoverNet'] == null ? undefined : MoneyOutputFromJSON(json['turnoverNet']),
        'turnoverGross': json['turnoverGross'] == null ? undefined : MoneyOutputFromJSON(json['turnoverGross']),
    };
}

export function PnoEntryToJSON(json: any): PnoEntry {
    return PnoEntryToJSONTyped(json, false);
}

export function PnoEntryToJSONTyped(value?: PnoEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'pnoNet': value['pnoNet'],
        'pnoGross': value['pnoGross'],
        'spendMarketing': MoneyOutputToJSON(value['spendMarketing']),
        'turnoverNet': MoneyOutputToJSON(value['turnoverNet']),
        'turnoverGross': MoneyOutputToJSON(value['turnoverGross']),
    };
}

